import React from "react";
import AffiliateTable from "./AffiliateTable";
import "../../Affiliates.scss";
import Loader from "SharedComponents/Loader/Loader";

const AffiliateIndex = ({ loading }) => {
    return (
        <div className="affiliates-grid">
            <div className="item-1">
                {loading ?
                    <Loader /> :
                    <AffiliateTable />
                }
            </div>
        </div>
    )
};

export default AffiliateIndex;